import { connect } from "react-redux";
import { ADMIN } from "MODULES/users/constants";

function AuthorizedOwner({ user, admin, record, children }) {
  const authorized =
    admin || record.getIn(["created_by", "id"]) === user.get("id");

  return authorized ? children : false;
}

export default connect(state => {
  const user = state.session.getIn(["user"]);
  return {
    user,
    admin: ADMIN === user.get("role")
  };
})(AuthorizedOwner);



// WEBPACK FOOTER //
// ./app/modules/shared/components/AuthorizedOwner/AuthorizedOwner.jsx